import { connect } from 'react-redux'
import TripsManagementPane from '../../components/trips/management/TripsManagementPane'
import { actionCreators } from '../../state/actions/trips'
import { IStoreState, ITripFilters } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  return {
    routeProps: ownProps,
    orgId: state.organizations.currentOrgId
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    updateTripFilters: (params: ITripFilters) => dispatch(actionCreators.updateTripFilters(params))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripsManagementPane)



// WEBPACK FOOTER //
// ./src/containers/trips/TripsManagementPane.ts